import { render } from "./tipoMermaList.vue?vue&type=template&id=b822a48c&scoped=true"
import script from "./tipoMermaList.vue?vue&type=script&lang=js"
export * from "./tipoMermaList.vue?vue&type=script&lang=js"

import "./tipoMermaList.vue?vue&type=style&index=0&id=b822a48c&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b822a48c"]])

export default __exports__